import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=61b288be&scoped=true&lang=pug"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=61b288be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b288be",
  null
  
)

export default component.exports